<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                title="Sitetype löschen ?"
                @cancel="$emit('input', false)"
                @ok="submit" ok-text="Fortfahren" :loading="loading"
        >
            Soll der Sitetype <b>{{ data ? data.Name : null }}</b>
            auf der Seite <b>{{ siteName }}</b>
            wirklich gelöscht werden? <br><br>
            Diese Aktion kann nicht mehr rückgängig gemacht werden.
        </Dialog>
        <Snackbar v-model="successSnackbar" color="success">Sitetype {{ data ? data.Name : null }} erfolgreich
            gelöscht.
        </Snackbar>
    </div>
</template>

<script>
import Dialog from "../../../components/Dialog";
import Snackbar from "../../../components/Snackbar";

export default {
    name: "DeleteSitetypeDialog",
    components: {Snackbar, Dialog},
    props: {
        value: {},
        data: {type: Object},
    },
    data: () => {
        return {
            successSnackbar: false,
            loading: false,
        }
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteName() {
            return this.vuexState.selectedSite ? this.vuexState.selectedSite.Name : '';
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            let data = await this.$store.dispatch('display/deleteSitetype', this.getBody());
            this.loading = false;
            if (data.Status) {
                this.successSnackbar = true;
                this.$emit('input', false); // set v-model to false -> close dialog
            }
        },
        getBody() {
            return {
                publisher_id: this.vuexState.selectedSite.PublisherId,
                site_id: this.vuexState.selectedSite.SiteId,
                type_id: this.data.SitetypeId
            }
        }
    }
}
</script>

<style scoped>

</style>